import { reducer } from "./reducer"
export const InventoryStockDocumentDefinitionReducer = reducer

export * from "./types"



// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/reducers/index.ts